import { all, takeLatest } from 'redux-saga/effects';

import { workerActions } from '../index';
import create from './create';
import deleteWorker from './delete';
import edit from './edit';
import getAll from './getAll';

const workerSagas = all([
  takeLatest(workerActions.createRequest, create),
  takeLatest(workerActions.editRequest, edit),
  takeLatest(workerActions.getAllRequest, getAll),
  takeLatest(workerActions.deleteRequest, deleteWorker),
]);

export default workerSagas;
